import { listDocuments } from "../documents/store.ts";
import { countStatements, countLinks } from "../documents/addressing.ts";

interface DocumentBrowserProps {
  onSelect: (documentId: string) => void;
}

export function DocumentBrowser({ onSelect }: DocumentBrowserProps) {
  const documents = listDocuments();

  return (
    <div className="doc-browser">
      <h1>AUGMENT / NLS</h1>
      <p className="subtitle">
        oN-Line System &mdash; Interactive document workspace
      </p>

      {documents.map((doc) => (
        <div
          key={doc.id}
          className="doc-list-item"
          onClick={() => onSelect(doc.id)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && onSelect(doc.id)}
        >
          <div className="title">{doc.title}</div>
          <div className="meta">
            {countStatements(doc.root)} statements &middot;{" "}
            {countLinks(doc.root)} links &middot; {doc.id}
          </div>
        </div>
      ))}

      <div
        style={{
          marginTop: "2rem",
          color: "var(--nls-hidden)",
          fontSize: "0.8em",
          lineHeight: "1.8",
        }}
      >
        <p>
          Recreation of the oN-Line System demonstrated in
          <br />
          &quot;The Mother of All Demos&quot; &mdash; Douglas Engelbart, Dec 9,
          1968
        </p>
        <p style={{ marginTop: "0.5rem" }}>
          Press <kbd style={{ color: "var(--nls-green)" }}>/</kbd> in the editor
          to enter commands &middot; Use viewspec codes to filter views
        </p>
      </div>
    </div>
  );
}
